module.exports = __webpack_public_path__ + "img/sshz.af3d62c0.png";